import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: 'Firebase 🔥 + Svelt + Bulma: Todo list (Google Auth)'
	},
});

export default app;